import { Dialog } from "@kobalte/core/dialog";
import { AnimateChildren } from "@storytell/ui/animation";
import { StButton } from "@storytell/ui/buttons";
import { TbX } from "solid-icons/tb";
import type { Component } from "solid-js";

interface DeleteInviteModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  inviteType: string;
}

export const DeleteInviteModal: Component<DeleteInviteModalProps> = (props) => {
  return (
    <AnimateChildren show={props.isOpen} enter={{ opacity: [0, 1], y: [10, 0] }} exit={{ opacity: [1, 0], y: [0, 10] }}>
      {(anim) => (
        <Dialog
          open={anim.isMounted()}
          onOpenChange={(val) => {
            if (!val) props.onClose();
          }}
        >
          <Dialog.Portal>
            <Dialog.Overlay class="fixed z-90 inset-0 bg-black/50 dark:bg-white/10" />
            <div ref={anim.ref} class="fixed z-90 inset-0 flex items-center justify-center">
              <Dialog.Content class="max-h-[80vh] relative w-screen text-primary-text max-w-md bg-panel overflow-y-auto rounded-xl p-6">
                <Dialog.CloseButton as={StButton} class="absolute top-4 right-4">
                  <TbX />
                </Dialog.CloseButton>

                <div class="mb-6">
                  <h3 class="text-lg font-medium mb-4">Delete this {props.inviteType} secret link?</h3>
                  <div class="bg-red-50 dark:bg-red-950/20 border border-red-200 dark:border-red-800 rounded-lg p-3">
                    <div class="flex items-center gap-2">
                      <span class="text-lg">🛑</span>
                      <p class="text-red-800 dark:text-red-200 text-sm">
                        All {props.inviteType}s invited via <strong>secret link</strong>, <strong>email</strong> or{" "}
                        <strong>domain access</strong> will lose access to this project.
                      </p>
                    </div>
                  </div>
                </div>

                <div class="flex items-center justify-end gap-3">
                  <StButton onClick={props.onClose} class="px-4 py-2 text-secondary-text hover:text-primary-text">
                    Cancel
                  </StButton>
                  <StButton onClick={props.onConfirm} class="px-4 py-2 text-white bg-red-600 hover:bg-red-700">
                    Yes, Delete Link
                  </StButton>
                </div>
              </Dialog.Content>
            </div>
          </Dialog.Portal>
        </Dialog>
      )}
    </AnimateChildren>
  );
};
